import React, { Component } from 'react'

import ButtonMaterial from '../../../materials/ButtonMaterial';

interface IProps {
    handleChangeAndPopUpModal:any
}

export default class ButtonDetailComponent extends Component <IProps> {
    render() {
        return (
            <div>
                <ButtonMaterial
                    disabled={''}
                    handleSubmit={this.props.handleChangeAndPopUpModal}
                    teksButton={''}
                    size={''}
                    shape={''}
                    className={''}
                    type={'primary'}
                    icon={'eye'}
                    style={{
                    float: 'right',
                    borderRadius: '8px',
                    color: '#fafafa',
                    paddingBottom: '3px',
                    background: '#7956EE',
                    borderColor: '#7956EE',
                    }}
                />
            </div>
        )
    }
}
